import React from 'react';
import PropTypes from 'prop-types';

export default function TestimonialSelector(props) {
  const { testimonials, selectedIndex, onSelection } = props;

  return (
    <div className="testimonial-selector">
      {testimonials.map(
        (_, index) =>
          index % 2 === 0 ? (
            <button
              key={index}
              className={`testimonial-selector-item ${
                selectedIndex === index ? 'selected' : ''
              }`}
              type="button"
              onClick={() => onSelection(index)}
            />
          ) : null,
      )}
    </div>
  );
}

TestimonialSelector.propTypes = {
  testimonials: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedIndex: PropTypes.number.isRequired,
  onSelection: PropTypes.func.isRequired,
};
